import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {SelectionModel} from '@angular/cdk/collections';
import {MatTableDataSource} from '@angular/material/table';
import * as _ from 'lodash';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';

@AcDialog({
  height: 380,
  width: 600
})
@Component({
  selector: 'routing-server-group-dialog',
  templateUrl: './routing-server-group-dialog.component.html',
  styleUrls: ['./routing-server-group-dialog.component.scss']
})
export class RoutingServerGroupDialogComponent implements OnInit, AfterViewInit {

  data;
  filter = '';

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig, private userPrivilege: UserPrivilegeService) {
    this.data = dialogConfig.dialogData;
  }

  selectableRoutingServers: MatTableDataSource<any>;
  selectedRoutingServers: MatTableDataSource<any>;
  selectableRoutingServersSubset = new SelectionModel<any>(true, []);
  selectedRoutingServersSubset = new SelectionModel<any>(true, []);

  onOk: () => void;
  canSubmit: boolean;
  formSettings = {valid: true, touched: false, dialogReady: false};
  formValidator = {};

  displayedColumns = ['status', 'name'];

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.clearLists();
    this.populatedDialogScope(this.data.routingServers, this.data.group, this.data.selectedInnerGroup, this.data.isEdit);
    this.dialogConfig.preSubmit = () => {
      this.selectedRoutingServers.data.forEach((server, index) => {
        server.priority = index;
      });

      const innerServerGroup = {
        id: 0,
        servers:  this.selectedRoutingServers.data,
        innerTitle: this.generateTitle(this.selectedRoutingServers.data), groupId: this.data.group.id
      };
      this.data.result = innerServerGroup;
      return true;
    };

    this.selectableRoutingServers.filterPredicate = (data, filterValue: string) => {
        return data.name.trim().toLowerCase().indexOf(filterValue) !== -1;
    };

  }

  clearLists(): void {
    this.selectableRoutingServersSubset.clear();
    this.selectedRoutingServersSubset.clear();
    this.selectableRoutingServers = new MatTableDataSource([]);
    this.selectedRoutingServers = new MatTableDataSource([]);

    this.selectableRoutingServers.filterPredicate = (data, filterValue: string) => {
      return data.name.trim().toLowerCase().indexOf(filterValue) !== -1;
    };
  }

  generateTitle(selectedRoutingServers): any {
    return selectedRoutingServers.map((server) => server.name).join(', ');
  }

  hasItemsToAdd(): any {
    return this.selectableRoutingServersSubset.selected.length > 0 && this.selectedRoutingServers.data.length < 10;
  }

  hasItemsToRemove(): any {
    return this.selectedRoutingServersSubset.selected.length > 0;
  }

  isUpAvailable(): any {
    return this.isValid(this.selectedRoutingServersSubset.selected) && this.notFirst(this.selectedRoutingServersSubset.selected);
  }

  isDownAvailable(): any {
    return this.isValid(this.selectedRoutingServersSubset.selected) && this.notLast(this.selectedRoutingServersSubset.selected);
  }

  onSelectSelectableRoutingServer(servers): any {
    if (this.selectableRoutingServersSubset.selected.indexOf(servers) === -1) {
      this.selectableRoutingServersSubset.select(servers);
    } else {
      this.selectableRoutingServersSubset.deselect(servers);
    }
  }

  onSelectSelectedRoutingServer(servers): any {
    if (this.selectedRoutingServersSubset.selected.indexOf(servers) === -1) {
      this.selectedRoutingServersSubset.select(servers);
    } else {
      this.selectedRoutingServersSubset.deselect(servers);
    }
  }

  isOkDisabled(): void {
    this.dialogConfig.submitButtonDisabled = this.selectedRoutingServers.data.length === 0
      || this.selectedRoutingServers.data.length > 10;
  }

  addToSelected(): void {
    this.selectedRoutingServers =
      new MatTableDataSource(this.selectedRoutingServers.data.concat(this.selectableRoutingServersSubset.selected));
    this.selectableRoutingServers = new MatTableDataSource(this.selectableRoutingServers.data.filter((server) => {
      return this.selectableRoutingServersSubset.selected.filter((serverSubset) => {
        return serverSubset.id === server.id;
      }).length === 0;
    }));

    this.refreshLists();
  }

  removeFromSelected(): void {
    this.selectableRoutingServers =
      new MatTableDataSource(this.selectableRoutingServers.data.concat(this.selectedRoutingServersSubset.selected));
    this.selectedRoutingServers = new MatTableDataSource(this.selectedRoutingServers.data.filter((server) => {
      return this.selectedRoutingServersSubset.selected.filter((serverSubset) => {
        return serverSubset.id === server.id;
      }).length === 0;
    }));
    this.refreshLists();
  }

  moveUp(): void {
    if (this.isValid(this.selectedRoutingServersSubset.selected)) {
      const selectedIndex = this.indexOfById(this.selectedRoutingServers.data, this.selectedRoutingServersSubset.selected[0]);
      const tempItem = this.selectedRoutingServers.data[selectedIndex - 1];

      this.selectedRoutingServers.data[selectedIndex - 1] = this.selectedRoutingServersSubset.selected[0];
      this.selectedRoutingServers.data[selectedIndex] = tempItem;
      this.selectedRoutingServers = new MatTableDataSource(this.selectedRoutingServers.data);
    }
  }

  moveDown(): void {
    if (this.isValid(this.selectedRoutingServersSubset.selected)) {
      const selectedIndex = this.indexOfById(this.selectedRoutingServers.data, this.selectedRoutingServersSubset.selected[0]);

      const tempItem = this.selectedRoutingServers.data[selectedIndex + 1];
      this.selectedRoutingServers.data[selectedIndex + 1] = this.selectedRoutingServersSubset.selected[0];
      this.selectedRoutingServers.data[selectedIndex] = tempItem;
      this.selectedRoutingServers = new MatTableDataSource(this.selectedRoutingServers.data);
    }
  }

  /* :: HELPER FUNCTIONS :: */

  populatedDialogScope(routingServers, group, selectedInnerGroup, isEdit): void {
    Array.prototype.push.apply(this.selectableRoutingServers.data, routingServers.filter((server) => {
      return !group.groups.find((innerGroup) => { return innerGroup.servers.find((s) => {
        return s.id === server.id;
      });
      }); }));

    if (isEdit && selectedInnerGroup) {
      Array.prototype.push.apply(this.selectedRoutingServers.data, selectedInnerGroup.servers.map((innerServer) => {
        return routingServers.find((server) => {
          return innerServer.id === server.id;
        });
      }));
    }
  }

  refreshLists(): void{
    this.selectedRoutingServersSubset.clear();
    this.selectableRoutingServersSubset.clear();
    this.isOkDisabled();

    this.selectableRoutingServers.filterPredicate = (data, filterValue: string) => {
      return data.name.trim().toLowerCase().indexOf(filterValue) !== -1;
    };

    this.selectableRoutingServers.filter = this.filter.trim().toLowerCase();
  }

  isValid(value): any {
    return _.isArray(value) && value.length > 0;
  }

  notFirst(value): any {
    return this.indexOfById(this.selectedRoutingServers.data, value[0]) > 0;
  }

  notLast(value): any {
    return this.indexOfById(this.selectedRoutingServers.data, value[0]) < this.selectedRoutingServers.data.length - 1;
  }

  indexOfById(dataArray, selectedItem): any {
    const itemsCount = dataArray.length;

    for (let i = 0; i < itemsCount; i++) {
      if (_.isEqual(dataArray[i], selectedItem)) {
        return i;
      }
    }
    return -1;
  }

  selectInSelectableRoutingServerList(routingServer): any {
    return this.selectableRoutingServersSubset.selected.indexOf(routingServer) !== -1;
  }

  selectInSelectedRoutingServerList(routingServer): any {
    return this.selectedRoutingServersSubset.selected.indexOf(routingServer) !== -1;
  }

  ngAfterViewInit(): void {
    this.isOkDisabled();
  }

  applyFilter(event: Event): void {
    this.selectableRoutingServers.filter = this.filter.trim().toLowerCase();
  }
}
